import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';
import { ProgressStepStateEnum } from '../ProgressStepState';

import { StepButton } from './StepButton';

export const MainStepMarker = styled.span`
    display: flex;
    flex: 0 0 ${theme.sizes[24]};
    align-items: center;
    justify-content: center;
    width: ${theme.sizes[24]};
    height: ${theme.sizes[24]};
    border-radius: 50%;
    color: ${theme.colors.foreground.onEmphasis};
    transition: background-color 120ms ease;

    ${StepButton}[data-state='${ProgressStepStateEnum.ACTIVE}'] & {
        background-color: ${theme.colors.accent.foreground};
    }

    ${StepButton}[data-state='${ProgressStepStateEnum.DONE}'] & {
        background-color: ${theme.colors.positive.foreground};
    }

    ${StepButton}[data-state='${ProgressStepStateEnum.DISABLED}'] & {
        background-color: ${theme.colors.foreground.disabled};
    }

    ${StepButton}[data-state='${ProgressStepStateEnum.IDLE}'] & {
        background-color: ${theme.colors.foreground.subtle};
    }

    @media (hover: hover) and (pointer: fine) {
        ${StepButton}:hover:not(:disabled):not([data-state='${ProgressStepStateEnum.DONE}']) & {
            background-color: ${theme.colors.foreground.default};
        }
    }
`;
